import * as React from 'react';
import { useStore } from '@tanstack/react-form';
import { useFormContext } from './FormProvider';
import { FormField as SharedFormField, type FormFieldConfig } from '../common/forms/FormField';

interface FormFieldsProps {
  fields: FormFieldConfig[];
  layout?: 'auto-grid' | 'stack';
  /** Opts every field into §2 error-timing gating (see shared FormField). */
  gateErrors?: boolean;
}

export function FormFields({ fields, layout = 'auto-grid', gateErrors = false }: FormFieldsProps) {
  const { form } = useFormContext();
  const submittedAttempts = useStore(form.store, (state) => state.submissionAttempts > 0);
  const submitted = gateErrors ? submittedAttempts : undefined;

  if (layout === 'stack') {
    return (
      <>
        {fields.map((config) => (
          <form.Field key={config.name} name={config.name}>
            {(field) => <SharedFormField field={field} config={config} submitted={submitted} />}
          </form.Field>
        ))}
      </>
    );
  }

  const result: React.ReactElement[] = [];
  let currentGroup: React.ReactElement[] = [];

  fields.forEach((config) => {
    const fieldElement = (
      <form.Field key={config.name} name={config.name}>
        {(field) => <SharedFormField field={field} config={config} submitted={submitted} />}
      </form.Field>
    );

    if (config.gridCols) {
      currentGroup.push(fieldElement);
    } else {
      if (currentGroup.length > 0) {
        result.push(
          <div key={`group-${result.length}`} className="grid grid-cols-2 gap-12">
            {currentGroup}
          </div>
        );
        currentGroup = [];
      }
      result.push(fieldElement);
    }
  });

  if (currentGroup.length > 0) {
    result.push(
      <div key={`group-${result.length}`} className="grid grid-cols-2 gap-12">
        {currentGroup}
      </div>
    );
  }

  return <>{result}</>;
}
